<template>
  <b-sidebar
    ref="drwr"
    class="drwr-no-padding drwr-title-no-pdng"
    @on-visible-change="visibleChanged"
    v-model="isShow"
    :width="drwrW"
    header-class="pd-0-f primary"
  >
    <!-- <div slot="header" class="wd-100p">
      <div class="ivu-card ivu-card-dis-hover gosm-toolbar">
        <div class="ivu-card-head">{{ getTitle() }}</div>
      </div>
      <div style="float: right">
        <button @click="visibleChanged(false)" class="button button-danger">
          Хаах
        </button>
      </div>
    </div> -->
    <div slot="header" class="content-header bd-b pd-0 wd-100p">
      <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px">
        <div class="pd-l-10">{{ getTitle() }}</div>
        <div
          id="navbarSupportedContent"
          class="collapse navbar-collapse order-2"
        >
          <button
            @click="visibleChanged(false)"
            class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto btn-danger"
          >
            <feather type="x"></feather> Хаах
          </button>
        </div>
      </nav>
    </div>
    <Row type="flex" style="height: 100%">
      <Col
        :span="4"
        style="
          border-right: 1px solid rgba(72, 94, 144, 0.16);
          background-color: #f8f9fc;
        "
      >
        <div class="p-md">
          <ul class="nav nav-aside pd-t-20 pd-l-20">
            <li class="nav-label">Төлөвлөгөө</li>
            <li :class="{ active: prms.mode == 1 }" class="nav-item">
              <a
                role="button"
                @click="$emit('set-rpt-mode', 1)"
                class="nav-link"
              >
                <span>Байгууллагын төлөвлөгөө</span></a
              >
              <a
                @click="downloadRep()"
                style="position: absolute; right: 0; top: 5px"
                ><i class="ivu-icon ivu-icon-md-download"></i
              ></a>
            </li>
            <li :class="{ active: prms.mode == 2 }" class="nav-item">
              <a
                role="button"
                @click="$emit('set-rpt-mode', 2)"
                class="nav-link"
              >
                <span
                  >{{
                    "planDepTitle"
                      | getConfigValueByKey(
                        $store.state.app.groupSettings,
                        "Хэлтсийн"
                      )
                  }}
                  төлөвлөгөө</span
                ></a
              >
              <a
                @click="downloadRep()"
                style="position: absolute; right: 0; top: 5px"
                ><i class="ivu-icon ivu-icon-md-download"></i
              ></a>
            </li>
            <li :class="{ active: prms.mode == 3 }" class="nav-item">
              <a
                role="button"
                @click="$emit('set-rpt-mode', 3)"
                class="nav-link"
              >
                <span>Үр дүнгийн төлөвлөгөө</span></a
              >
              <a
                @click="downloadRep()"
                style="position: absolute; right: 0; top: 5px"
                ><i class="ivu-icon ivu-icon-md-download"></i
              ></a>
            </li>
            <li class="nav-label m-t-md pd-t-20">Тайлан</li>
            <li :class="{ active: prms.mode == 5 }" class="nav-item">
              <a
                role="button"
                @click="$emit('set-rpt-mode', 5)"
                class="nav-link"
              >
                <span>Байгууллагын тайлан</span></a
              >
              <a
                role="button"
                @click="downloadRep()"
                style="position: absolute; right: 0; top: 5px"
                ><i class="ivu-icon ivu-icon-md-download"></i
              ></a>
            </li>
            <li :class="{ active: prms.mode == 6 }" class="nav-item">
              <a
                role="button"
                @click="$emit('set-rpt-mode', 6)"
                class="nav-link"
              >
                <span
                  >{{
                    "planDepTitle"
                      | getConfigValueByKey(
                        $store.state.app.groupSettings,
                        "Хэлтсийн"
                      )
                  }}
                  тайлан</span
                ></a
              >
              <a
                role="button"
                @click="downloadRep()"
                style="position: absolute; right: 0; top: 5px"
                ><i class="ivu-icon ivu-icon-md-download"></i
              ></a>
            </li>

            <li :class="{ active: prms.mode == 66 }" class="nav-item">
              <a
                role="button"
                @click="$emit('set-rpt-mode', 66)"
                class="nav-link"
              >
                <span>Үр дүнгийн тайлан</span></a
              >
              <a
                @click="downloadRep()"
                style="position: absolute; right: 0; top: 5px"
                ><i class="ivu-icon ivu-icon-md-download"></i
              ></a>
            </li>
          </ul>
        </div>
      </Col>
      <Col :span="20">
        <div style="overflow: auto" class="p-md m-r-md">
          <template v-if="prms.mode == 1">
            <div class="ivu-row m-b-sm">
              <div class="ivu-col ivu-col-span-4">
                <Select v-model="dateRangeMode">
                  <Option :value="-1" label="Өмнөх оны">Өмнөх оны</Option>
                  <Option :value="0" label="Бүтэн жилээр">Бүтэн жилээр</Option>
                  <Option :value="1" label="Энэ оны 1-р хагас">Энэ оны 1-р хагас</Option>
                  <Option :value="2" label="Энэ оны 2-р хагас">Энэ оны 2-р хагас</Option>
                  <Option :value="3" label="Энэ сараар">Энэ сараар</Option>
                  <Option :value="4" label="Дараа оны">Дараа оны</Option>
                </Select>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateStart"
                  @on-change="(value) => (dateStart = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateEnd"
                  @on-change="(value) => (dateEnd = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-6"></div>
              <div class="ivu-col ivu-col-span-4 text-center"></div>
            </div>

            <div id="printablePage">
              <div class="topRow" style="text-align: right; font-size: 13px">
                {{
                  getConfigValueByKey("rptOrgPrefix")
                }}:................................................................../{{
                  getConfigValueByKey("groupDirector")
                }}/
              </div>

              <div style="text-align: center" class="m-t-sm">
                {{ getConfigValueByKey("companyName") }} - н үйл ажиллагааны
                жилийн төлөвлөгөө {{ dateStart | moment("YYYY") }} он
              </div>
              <br />

              <table
                align="center"
                width="100%"
                border="1"
                bordercolor="#333"
                style="vertical-align: top"
                class="mainTble"
              >
                <tbody>
                  <tr bgcolor="#e5f0ff">
                    <td rowspan="3">№&nbsp;</td>
                    <td rowspan="3">
                      {{ getConfigValueByKey("planColumnRoot1") }}
                    </td>
                    <!-- <td rowspan="3">{{getConfigValueByKey('planColumnRoot2')}}</td> -->
                    <td rowspan="3">
                      Зорилтыг хэрэгжүүлэх үйл ажиллагааны үе шатууд
                    </td>
                    <td colspan="48" bgcolor="#cae0ff" class="auto-style1">
                      Хугацаа
                    </td>
                    <td rowspan="3">Хугацаа</td>
                    <td rowspan="3">Шалгуур үзүүлэлтийн хүрэх түвшин</td>
                    <td rowspan="3">Төсөв /мян.төг/</td>
                    <td rowspan="3">Хариуцах нэгжийн нэр</td>
                    <!-- <td rowspan="3">Хамтрах нэгжийн нэр</td> -->
                  </tr>
                  <tr bgcolor="#e5f0ff">
                    <td v-for="i in 12" colspan="4">{{ i }} сар</td>
                  </tr>
                  <tr class="oddRow">
                    <template v-for="i in 12">
                      <td>I</td>
                      <td>II</td>
                      <td>III</td>
                      <td>IV</td>
                    </template>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>2</td>
                    <!-- <td>3</td> -->
                    <td>3</td>
                    <td colspan="48">4</td>
                    <td>5</td>
                    <td>6</td>
                    <td>7</td>
                    <td>8</td>
                    <!-- <td>9</td> -->
                  </tr>

                  <template v-for="(t, i) in list">
                    <tr
                      v-if="isDrawGroup(i) && t.mainType != null"
                      :key="`tpls_${i}`"
                    >
                      <td colspan="54">
                        <b>{{ t.mainType }}</b>
                      </td>
                    </tr>
                    <tr :key="`tpls2_${i}`">
                      <template v-if="isDrawGroup(i)">
                        <td :rowspan="prodRowCount(t.projectId)">
                          {{ i + 1 + ".1" }}
                        </td>
                        <td
                          style="min-width: 200px"
                          :rowspan="prodRowCount(t.projectId)"
                        >
                          {{ t.projectName }}
                        </td>
                      </template>
                      <td style="min-width: 200px">
                        <b>Бүтээгдэхүүн {{ i + 1 }}</b>
                        <br />
                        {{ t.task }}
                      </td>

                      <template v-for="mi in 12">
                        <template v-for="wi in 4">
                          <td
                            :key="`taxpls_${mi}_${wi}`"
                            v-if="
                              isInDate(mi, wi, t.dueStartDate, t.dueDate, t)
                            "
                            style="background-color: #4791b5 !important"
                          >
                            {{ mi }}
                            <br />
                            {{ wname(wi) }}
                          </td>
                          <td
                            :key="`taxp2ls_${mi}_${wi}`"
                            style="min-width: 24px"
                            v-else
                          ></td>
                        </template>
                      </template>

                      <td
                        v-html="printDurationForPlan(t.dueStartDate, t.dueDate)"
                      ></td>

                      <td><b>Тоо: </b>{{ t.taskEn }}</td>
                      <td>{{ formatMoney(t.budget, ",", ".") }}</td>
                      <td>
                        <template
                          v-if="isDrawDepart(i, di)"
                          v-for="(d, di) in t.sharedUsers"
                          ><span :key="`taxpls_${di}`">
                            {{ d.departName + ", " }}
                          </span>
                        </template>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </template>
          <template v-else-if="prms.mode == 2">
            <div class="ivu-row m-b-sm">
              <div class="ivu-col ivu-col-span-4">
                <Select v-model="dateRangeMode">
                  <Option :value="-1" label="Өмнөх оны">Өмнөх оны</Option>
                  <Option :value="0" label="Бүтэн жилээр">Бүтэн жилээр</Option>
                  <Option :value="1" label="Энэ оны 1-р хагас">Энэ оны 1-р хагас</Option>
                  <Option :value="2" label="Энэ оны 2-р хагас">Энэ оны 2-р хагас</Option>
                  <Option :value="3" label="Энэ сараар">Энэ сараар</Option>
                  <Option :value="4" label="Дараа оны">Дараа оны</Option>
                </Select>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateStart"
                  @on-change="(value) => (dateStart = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateEnd"
                  @on-change="(value) => (dateEnd = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-6">
                <depart-cascader
                  :id="departId"
                  :key="departComponentKey"
                  v-model="departId"
                  @on-change="departChanged"
                />
              </div>
              <div class="ivu-col ivu-col-span-4 text-center">
                <!-- <Button @click="init();" type="primary">Хайх</Button> -->
              </div>
            </div>

            <div id="printablePage">
              <table width="100%" align="center">
                <tbody>
                  <tr>
                    <td
                      class="topRow"
                      style="
                        text-align: right;
                        font-size: 13px;
                        text-transform: uppercase;
                      "
                    >
                      {{ getConfigValueByKey("rptOrgPrefix") }}
                      ...................................{{
                        getConfigValueByKey("companyDirector")
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table align="center" width="100%">
                <tbody>
                  <tr>
                    <td style="padding-top: 20px" class="center">
                      <strong style="text-transform: uppercase"
                        >{{ $store.state.user.depart }}
                        {{ dateStart | moment("YYYY") }} ОНЫ ТӨЛӨВЛӨГӨӨ</strong
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />

              <table
                align="center"
                width="100%"
                border="1"
                bordercolor="#333"
                style="vertical-align: top"
                class="auto-style4"
              >
                <tbody>
                  <tr bgcolor="#e5f0ff">
                    <td rowspan="3" class>№&nbsp;</td>
                    <td width="20%" rowspan="3">Төсөл хөтөлбөр</td>
                    <td width="30%" rowspan="3" class>Хийгдэх ажлууд</td>
                    <td rowspan="3" class>хэмжих нэгж</td>
                    <td colspan="12" bgcolor="#cae0ff" class="auto-style1">
                      {{ dateStart | moment("YYYY") }}
                    </td>
                    <td rowspan="3">Хугацаа</td>
                    <td rowspan="3" class>Хариуцан гүйцэтгэх ажилтан</td>
                  </tr>
                  <tr bgcolor="#e5f0ff">
                    <td v-for="wi in 4" colspan="3">{{ wname(wi) }}</td>
                  </tr>

                  <tr class="oddRow">
                    <td
                      v-for="mi in 12"
                      class="auto-style14"
                      style="min-width: 24px"
                    >
                      {{ mi }}
                    </td>
                  </tr>

                  <template v-for="(t, i) in listDepart">
                    <tr v-if="isDrawGroupForDepart(i) && t.mainType != null">
                      <td colspan="56">
                        <b>{{ t.mainType }}</b>
                      </td>
                    </tr>
                    <tr>
                      <template v-if="isDrawGroupForDepart(i)">
                        <td :rowspan="prodRowCountDepart(t.projectId)">
                          {{ i + 1 + ".1" }}
                        </td>
                        <td
                          style="min-width: 200px; text-align: left"
                          :rowspan="prodRowCountDepart(t.projectId)"
                        >
                          <b>Бүтээгдэхүүн {{ i + 1 }}</b>
                          <br />
                          {{ t.projectName }}
                        </td>
                      </template>
                      <td style="min-width: 200px; text-align: left">
                        {{ i + 1 + ". " + t.task }}
                      </td>
                      <td><b>Тоо: </b>{{ t.taskEn }}</td>
                      <template v-for="mi in 12">
                        <td
                          v-if="isInMonth(mi, t.dueStartDate, t.dueDate, t)"
                          style="background-color: #4791b5 !important"
                        ></td>
                        <td style="min-width: 24px" v-else></td>
                      </template>
                      <td
                        v-html="printDurationForPlan(t.dueStartDate, t.dueDate)"
                      ></td>
                      <td>
                        <template v-for="(u, ui) in t.sharedUsers">
                          {{ u.fullName }},
                        </template>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </template>

          <template v-else-if="prms.mode == 3">
            <div class="ivu-row m-b-sm">
              <div class="ivu-col ivu-col-span-4">
                <Select v-model="dateRangeMode">
                  <Option :value="-1" label="Өмнөх оны">Өмнөх оны</Option>
                  <Option :value="0" label="Бүтэн жилээр">Бүтэн жилээр</Option>
                  <Option :value="1" label="Энэ оны 1-р хагас">Энэ оны 1-р хагас</Option>
                  <Option :value="2" label="Энэ оны 2-р хагас">Энэ оны 2-р хагас</Option>
                  <Option :value="3" label="Энэ сараар">Энэ сараар</Option>
                  <Option :value="4" label="Дараа оны">Дараа оны</Option>
                </Select>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateStart"
                  @on-change="(value) => (dateStart = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateEnd"
                  @on-change="(value) => (dateEnd = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-6">
                <!-- <depart-cascader :id="departId" :key="departComponentKey" v-model="departId"  @on-change="departChanged" /> -->
              </div>
              <div class="ivu-col ivu-col-span-4 text-center">
                <!-- <Button @click="init();" type="primary">Хайх</Button> -->
              </div>
            </div>

            <div id="printablePage">
              <table width="80%" align="center">
                <tbody>
                  <tr>
                    <td
                      v-if="chiefData.loaded"
                      class="topRow"
                      style="text-align: right; font-size: 13px"
                    >
                      {{ chiefData.depart }}
                      ...................................{{ chiefData.chief }}
                    </td>
                    <td
                      v-else
                      class="topRow"
                      style="text-align: right; font-size: 13px"
                    >
                      {{ getConfigValueByKey("companyName") }}
                      ...................................{{
                        getConfigValueByKey("companyDirector")
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table align="center" width="80%">
                <tbody>
                  <tr>
                    <td
                      style="padding-top: 20px; text-align: center !important"
                    >
                      <strong style="text-transform: uppercase">
                        <span>{{ $store.state.user.depart }}</span>
                        {{ $store.state.user.position }}
                        {{ $store.state.user.fullName }}
                        {{ dateStart | moment("YYYY") }} ОНЫ ТӨЛӨВЛӨГӨӨ
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />

              <table
                align="center"
                width="100%"
                border="1"
                bordercolor="#333"
                style="vertical-align: top"
                class="auto-style4"
              >
                <tbody>
                  <tr bgcolor="#e5f0ff">
                    <td rowspan="3" class>№&nbsp;</td>
                    <td width="20%" rowspan="3">Төсөл хөтөлбөр</td>
                    <td width="30%" rowspan="3" class>Хийгдэх ажлууд</td>
                    <td rowspan="3" class>хэмжих нэгж</td>
                    <td colspan="12" bgcolor="#cae0ff" class="auto-style1">
                      {{ dateStart | moment("YYYY") }}
                    </td>
                    <td rowspan="3" class>Хугацаа</td>
                  </tr>
                  <tr bgcolor="#e5f0ff">
                    <td v-for="wi in 4" colspan="3">{{ wname(wi) }}</td>
                  </tr>

                  <tr class="oddRow">
                    <td
                      v-for="mi in 12"
                      class="auto-style14"
                      style="min-width: 24px"
                    >
                      {{ mi }}
                    </td>
                  </tr>

                  <template v-for="(t, i) in listUser">
                    <tr v-if="isDrawGroupForUser(i) && t.mainType != null">
                      <td colspan="56">
                        <b>{{ t.mainType }}</b>
                      </td>
                    </tr>
                    <tr>
                      <template v-if="isDrawGroupForUser(i)">
                        <td
                          :rowspan="
                            prodRowCountUser(
                              t.projectId,
                              $store.state.user.userId
                            )
                          "
                        >
                          {{ i + 1 + ".1" }}
                        </td>
                        <td
                          style="min-width: 200px; text-align: left"
                          :rowspan="
                            prodRowCountUser(
                              t.projectId,
                              $store.state.user.userId
                            )
                          "
                        >
                          <b>Бүтээгдэхүүн {{ i + 1 }}</b>
                          <br />
                          {{ t.projectName }}
                        </td>
                      </template>
                      <td style="min-width: 200px; text-align: left">
                        {{ i + 1 + ". " + t.task }}
                      </td>
                      <td><b>Тоо: </b>{{ t.taskEn }}</td>
                      <template v-for="mi in 12">
                        <td
                          v-if="isInMonth(mi, t.dueStartDate, t.dueDate, t)"
                          style="background-color: #4791b5 !important"
                        ></td>
                        <td style="min-width: 24px" v-else></td>
                      </template>
                      <td
                        v-html="printDurationForPlan(t.dueStartDate, t.dueDate)"
                      ></td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </template>

          <template v-else-if="prms.mode == 4">
            <div id="printablePage">
              <table width="100%" align="center">
                <tbody>
                  <tr>
                    <td
                      style="
                        padding-top: 20px;
                        font-size: 14px;
                        text-align: center;
                      "
                    >
                      <strong>ҮР ДҮНГИЙН ГЭРЭЭ</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <b id style="font-weight: normal" contenteditable="true">
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1.Гэрээ байгуулагч талууд:</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >1.1.Нэг талаас: Менежер (Төсвийн шууд захирагч)
                  </span>
                </p>
                <br />
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >{{ getConfigValueByKey("companyName") }}</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    display: inline !important;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >захирал&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                      getConfigValueByKey("companyDirector")
                    }}</span
                  >
                </p>

                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;(албан тушаал,
                    нэр)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(эцэг/
                    эх/-ийн нэр, нэр)
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >1.2.Нөгөө талаас: Төрийн жинхэнэ албан хаагч
                  </span>
                </p>

                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span>{{ $store.state.user.depart }}</span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >{{
                      $store.state.user.position
                    }}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                      $store.state.user.fullName
                    }}
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >(албан
                    тушаал)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >(эцэг /эх/-ийн нэр, нэр)</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >бид дор дурдсан асуудлаар харилцан тохиролцсоны үндсэн дээр
                    энэхүү гэрээг байгуулав.</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >2.Гэрээний агуулга, зорилго</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >2.1. Энэхүү гэрээнд төрийн жинхэнэ албан хаагчаас
                    хэрэгжүүлэх нийт болон тусгай ажил, үйлчилгээнүүд, мэдлэг
                    чадвараа дээшлүүлэх зорилтууд, тэдгээрийн &nbsp;гүйцэтгэлийн
                    шалгуур үзүүлэлт (тоо, чанар, хугацаа)-үүд болон бусад эрх
                    үүргийг тусгав.
                  </span>
                </p>
                <span
                  style="
                    font-size: 14.666666666666666px;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre-wrap;
                  "
                >
                  <span class="Apple-tab-span" style="white-space: pre"></span
                  >2.2.Энэхүү гэрээний зорилго нь үйл ажиллагаагаа оновчтой
                  төлөвлөж хэрэгжүүлэх, ажлын байрны шаардлагад нийцүүлэн мэдлэг
                  чадвараа дээшлүүлэх, төрийн албаны тухай хууль тогтоомж,
                  стандарт, ёс зүйн хэм хэмжээг чанд сахиж, сонирхлын зөрчилгүй
                  ажиллах талаар төрийн жинхэнэ албан хаагчийн тухайн жилд
                  гүйцэтгэх үүрэг, хүлээх хариуцлагыг тодорхойлоход оршино
                </span>
              </b>
              <p></p>
              <p></p>
              <br />
              <b id style="font-weight: normal">
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: underline;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >НЭГ.ТАЛУУДЫН ХҮЛЭЭХ ҮҮРЭГ</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >1. Төрийн жинхэн албан хаагчийн хүлээх үүрэг
                  </span>
                </p>
              </b>

              <br />
              <br />
              <br />

              <b id style="font-weight: normal" contenteditable="true">
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1.4.</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    Төрийн алба, төрийн жинхэнэ албан хаагчтай холбоотой хууль
                    тогтоомж, төрийн албаны болон үйлчилгээний стандартыг
                    &nbsp;мөрдөж, төрийн жинхэнэ &nbsp;албан хаагчийн ёс зүйн
                    хэм хэмжээг чанд сахиж, ашиг сонирхлын зөрчил гаргахгүй
                    ажиллана.
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1.5.</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Гэрээний биелэлтийг &nbsp;менежерт улирал тутам мэдээллэж,
                    &nbsp;хагас, бүтэн жилээр тайлагнана.</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >2. Менежерийн хүлээх үүрэг</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >2.1.Төрийн жинхэнэ албан хаагчтай байгуулах гэрээнд тусгаж
                    хэрэгжүүлэх нийт болон тусгай ажил, үйлчилгээ, тэдгээрийн
                    гүйцэтгэлийн шалгуур үзүүлэлтийг хамтран тодорхойлно.</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >2.2.Төрийн жинхэнэ албан хаагчийн мэдлэг чадвараа
                    дээшлүүлэх зорилт, тэдгээрийн гүйцэтгэлийн шалгуур
                    үзүүлэлтийг хамтран тодорхойлно.
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >2.3.Төрийн жинхэнэ албан хаагчийн гэрээнд тусгагдсан нийт
                    болон тусгай ажил, үйлчилгээ, мэдлэг чадвараа дээшлүүлэх
                    зорилтуудыг хэрэгжүүлэхэд нь түүнд байнгын дэмжлэг туслалцаа
                    үзүүлж, гэрээний биелэлтийг хангах боломж, нөхцөлийг
                    бүрдүүлнэ.
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: underline;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >ХОЁР.БУСАД ЗҮЙЛ</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >3. Гэрээнд нэмэлт, өөрчлөлт оруулах</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >3.1.Гэрээнд нэмэлт, өөрчлөлт оруулах асуудлыг талууд
                    харилцан тохиролцсоны үндсэн дээр шийдвэрлэж, албажуулан
                    гэрээнд хавсаргана.
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >4.Гэрээ байгуулах болон дүгнэх хугацаа
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >4.1.Гэрээг {{ dateStart | moment("YYYY") }} оны 01 дүгээр
                    сарын 20 -ны өдрөөс {{ dateStart | moment("YYYY") }} оны 12
                    дугаар сарын 31 -ний өдрийг дуусталх хугацаагаар байгуулав.
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >Энэхүү гэрээний хугацаа сунгагдахгүй.
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >4.2. Төрийн жинхэнэ албан хаагч гэрээний биелэлтийг
                    {{ dateStart | moment("YYYY") }} &nbsp;оны 12 дүгээр сарын
                    &nbsp;20 -ны дотор багтаан тайлагнаж, менежер &nbsp;&nbsp;{{
                      dateStart | moment("YYYY")
                    }}
                    оны 12 &nbsp;дүгээр сарын 25 -ний дотор багтаан дүгнэнэ.
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >5. Гэрээний урамшуулал ба хариуцлага
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    5.1.Төрийн жинхэнэ албан хаагч гэрээгээр хүлээсэн үүргээ
                    &nbsp;хангалттай сайн биелүүлсэн тохиолдолд түүнийг
                    урамшуулах асуудлыг байгууллагын эрх бүхий албан тушаалтан
                    холбогдох хууль тогтоомж, эрх зүйн акт, Хөдөлмөрийн дотоод
                    журамд заасны &nbsp;дагуу шийдвэрлэнэ.
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >5.2.Төрийн жинхэнэ албан хаагч &nbsp;гэрээгээр хүлээсэн
                    үүргээ хангалтгүй биелүүлсэн тохиолдолд менежер түүнд
                    туслалцаа дэмжлэг үзүүлэх, эсхүл холбогдох хууль тогтоомжид
                    заасны дагуу байгууллагын эрх бүхий албан тушаалтан түүнд
                    хариуцлага хүлээлгэнэ.
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6.Гэрээ
                    байгуулсан:</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Менежер</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >{{ getConfigValueByKey("companyName") }}</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ЗАХИРАЛ
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >…………………………….
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/{{
                      getConfigValueByKey("companyDirector")
                    }}/
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Тэмдэг</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >(гарын үсэг)</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >Менежер
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <br />{{ getConfigValueByKey("companyName") }}
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ОРЛОГЧ
                    ДАРГА
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;........................................&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >//
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    text-indent: 198px;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >(</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >гарын үсэг</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >)</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >Менежер
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <br />{{ getConfigValueByKey("companyName") }}
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ОРЛОГЧ
                    ДАРГА
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;........................................&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >//
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    text-indent: 198px;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >(</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >гарын үсэг</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >)</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Менежер</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span>Удирдлага</span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.8;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                    display: inline !important;
                  "
                >
                  <span
                    style="
                      font-size: 14.6667px;
                      font-family: Arial;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ДАРГА
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >........................................
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    text-indent: 198px;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >(
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >гарын үсэг</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >)</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Төрийн жинхэнэ</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  ></span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >албан хаагч</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span>{{ $store.state.user.depart }}</span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                    {{ $store.state.user.position }}
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >……………………………….. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/{{
                      $store.state.user.fullName
                    }}/
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >(гарын үсэг)
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.7999999999999998;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                    text-indent: 218px;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;......................... &nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </p>
                <span
                  style="
                    font-size: 14.666666666666666px;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre-wrap;
                  "
                >
                  <span class="Apple-tab-span" style="white-space: pre"></span
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span class="Apple-tab-span" style="white-space: pre"></span>
                </span>
                <span
                  style="
                    font-size: 14.666666666666666px;
                    font-family: Arial;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: italic;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre-wrap;
                  "
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span class="Apple-tab-span" style="white-space: pre"></span
                  >&nbsp;(огноо)
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </b>
            </div>
          </template>
          <template
            v-else-if="prms.mode == 5 || prms.mode == 6 || prms.mode == 66"
          >
            <div class="ivu-row m-b-sm" style="display: none">
              <div class="ivu-col ivu-col-span-4">
                <Select v-model="dateRangeMode">
                  <Option :value="-1" label="Өмнөх оны">Өмнөх оны</Option>
                  <Option :value="0" label="Бүтэн жилээр">Бүтэн жилээр</Option>
                  <Option :value="1" label="Энэ оны 1-р хагас">Энэ оны 1-р хагас</Option>
                  <Option :value="2" label="Энэ оны 2-р хагас">Энэ оны 2-р хагас</Option>
                  <Option :value="3" label="Энэ сараар">Энэ сараар</Option>
                  <Option :value="4" label="Дараа оны">Дараа оны</Option>
                </Select>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateStart"
                  @on-change="(value) => (dateStart = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateEnd"
                  @on-change="(value) => (dateEnd = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-6">
                <!-- <depart-cascader :id="departId" :key="departComponentKey" v-model="departId"  @on-change="departChanged" /> -->
              </div>
              <div class="ivu-col ivu-col-span-4 text-center">
                <!-- <Button @click="init();" type="primary">Хайх</Button> -->
              </div>
            </div>
            <div v-if="prms.mode == 6">
              <depart-cascader
                ref="dprtCsdr2"
                :id="departId"
                :key="departComponentKey"
                v-model="departId"
                @on-change="departChanged2"
              />
              <!-- @on-flat="onDepFlat" -->
            </div>

            <div id="printablePage">
              <table width="100%" align="center">
                <tbody>
                  <tr>
                    <td class style="text-align: left; font-size: 13px">
                      Хэвлэсэн: {{ formatAllDate(new Date()) }},
                      {{ $store.state.user.fullName }}
                    </td>
                    <td
                      style="text-align: right; font-size: 13px; width: 300px"
                    >
                      Хамрах хугацаа: {{ dateStart | formatDateYMD("/") }} -
                      {{ dateEnd | formatDateYMD("/") }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table width="100%" align="center">
                <tbody>
                  <tr>
                    <td
                      style="
                        padding-top: 20px;
                        font-size: 14px;
                        text-align: center;
                      "
                    >
                      <strong
                        v-if="prms.mode == 5"
                        style="text-transform: uppercase"
                      >
                        {{ getConfigValueByKey("companyName") }} - н ТАЙЛАН
                      </strong>
                      <strong
                        v-else-if="prms.mode == 6"
                        style="text-transform: uppercase"
                      >
                        {{ departCurName }} - н ТАЙЛАН
                      </strong>
                      <strong v-else-if="prms.mode == 66">
                        {{ $store.state.user.depart }}- н
                        {{ $store.state.user.position }}<br />
                        {{ $store.state.user.fullName }}-н
                        {{ dateEnd | formatDateY("/") }} оны ТАЙЛАН
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        padding-top: 20px;
                        font-size: 14px;
                        text-align: left;
                      "
                    ></td>
                  </tr>
                </tbody>
              </table>

              <div style="overflow: auto">
                <table
                  align="center"
                  width="100%"
                  border="1"
                  bordercolor="#333"
                  style="vertical-align: top"
                  class="auto-style4"
                >
                  <thead>
                    <tr bgcolor="#e5f0ff">
                      <th>Д/д</th>
                      <th>Үйл ажиллагаа<br />(Арга хэмжээ)</th>
                      <th>Төсөв</th>
                      <th>Шалгуур үзүүлэлт</th>
                      <th>Суурь түвшин</th>
                      <th>Зорилтот түвшин</th>
                      <th>
                        Хүрсэн түвшин буюу хэрэгжилт <br />/хүрээгүй бол
                        тайлбар/
                      </th>
                      <th>Гүйцэтгэл %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(type, ti) in list2022.mainList">
                      <tr :key="`01_${ti}`">
                        <th
                          colspan="8"
                          style="
                            text-transform: uppercase;
                            font-weight: bold;
                            background-color: #cae0ff;
                          "
                        >
                          {{ getNum(ti + 1) }}. {{ type.tc.name }}
                        </th>
                      </tr>
                      <template v-for="(pt, pti) in type.pt">
                        <tr :key="`02_${ti}_${pti}`">
                          <td colspan="8">
                            Зорилт {{ ti + 1 }}.{{ pti + 1 }}
                            <b>{{ pt.pt.name }}</b>
                          </td>
                        </tr>
                        <template v-for="(task, tcti) in pt.tasks">
                          <tr :key="`03_${ti}_${pti}_${tcti}`">
                            <td>{{ ti + 1 }}.{{ pti + 1 }}.{{ tcti + 1 }}</td>
                            <td>
                              <a @click="showTask(task)">{{ task.task }}</a>
                            </td>
                            <td>{{ gormatDec(task.dec3) }}</td>
                            <td>{{ task.s1 }}</td>
                            <td>{{ task.phone }}</td>
                            <td>{{ task.mobile }}</td>
                            <td>{{ task.execution }}</td>
                            <td>{{ task.perc }}</td>
                          </tr>
                        </template>
                      </template>
                    </template>

                    <template v-for="(tc, ti) in list2022.typesRaw">
                      <tr :key="`${ti}_mainType`">
                        <th
                          colspan="8"
                          style="
                            text-transform: uppercase;
                            font-weight: bold;
                            background-color: #cae0ff;
                          "
                        >
                          {{ getNum(ti + 1) }}. {{ tc.name }}
                        </th>
                      </tr>

                      <template v-for="(pt, pti) in list2022.zorilts">
                        <template
                          v-if="
                            list2022.list.filter(
                              (x) =>
                                x.projectType != null &&
                                x.projectType.id == pt.id &&
                                x.locTypeId == tc.id
                            ).length > 0
                          "
                        >
                          <tr
                            :key="`${ti}_${pti}_projtypes`"
                            v-show="pt.code != 'yr_2022'"
                          >
                            <!-- <th colspan="8" class="text-uppercase">Зорилт {{tc.ord}}.{{pt.ord}}. {{pt.name}}</th> -->
                            <th colspan="8" class="text-uppercase">
                              {{ zoriltIndex }}Зорилт {{ ti + 1 }}.{{
                                pti + 1
                              }}********************. {{ pt.name }}
                            </th>
                          </tr>
                          <template
                            v-for="(pj, pi) in list2022.list.filter(
                              (x) =>
                                x.projectType != null &&
                                x.projectType.id == pt.id &&
                                x.locTypeId == tc.id
                            )"
                          >
                            <tr
                              v-show="isDrawGroup(pi, 'projectTypeId')"
                              :key="`${ti}_${pti}_${pi}_projs`"
                            >
                              <th colspan="8" class="text-uppercase text-left">
                                Бүтээгдэхүүн {{ tc.ord }}.{{
                                  pt.code != "yr_2022" ? pt.ord + "." : ""
                                }}{{ pi + 1 }}. {{ pj.projectName }}
                              </th>
                            </tr>
                            <template
                              v-for="(tt, tti) in list2022.list.filter(
                                (x) => x.projectId == pj.projectId
                              )"
                            >
                              <tr
                                :key="`${ti}_${pti}_${pi}_${tti}_tasks`"
                                v-show="isDrawGroup(pi, 'projectTypeId')"
                              >
                                <td>{{ tti * (pi + 1) + 1 }}</td>
                                <td>{{ tt.task }}</td>
                                <td>{{ gormatDec(tt.dec3) }}</td>
                                <td>{{ tt.s1 }}</td>
                                <td>{{ tt.phone }}</td>
                                <td>{{ tt.mobile }}</td>
                                <td>{{ tt.execution }}</td>
                                <td>{{ tt.perc }}</td>
                              </tr>
                            </template>
                          </template>
                        </template>
                      </template>
                    </template>
                    <!-- <template v-for="(t,ti) in list">
                      <tr :key="`mt${ti}`" v-if="isDrawGroup(ti) && t.mainType!=null">
                        <td colspan="8">
                          {{t.mainType}}
                        </td>
                      </tr>
                      <tr :key="`mt${ti}`" >
                        <td colspan="8" style="text-align: left">
                          {{t.projectName}}
                        </td>
                      </tr>
                      <tr :key="`gp${ti}`">
                        <td>{{ti}}</td>
                        <td>{{t.task}}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </template> -->
                  </tbody>
                </table>
                <!-- <div v-for="(t,ti) in list" :key="`gp${ti}`">
                  {{t.projectName}}
                  <hr/>
                  {{t.mainType}}
                  <hr/>
                  {{t.task}}
                </div> -->
              </div>

              <!-- <div class="tableFixHead" style="display: none;">
                <table align="center"
                width="100%"
                border="1"
                bordercolor="#333"
                style="vertical-align: top"
                class="auto-style4">
                  <thead>
                    <tr bgcolor="#e5f0ff">
                      <th>№&nbsp;</th>
                      <th width="15%">Төсөл хөтөлбөр</th>
                      <th width="15%">Хийгдэх ажлууд</th>
                      <th width="90px">Хугацаа</th>
                      <th colspan="6">Төсөв</th>
                      <th>Хариуцан гүйцэтгэх ажилтан, Гүйцэтгэл</th>
                    </tr>
                    <tr class="oddRow">
                      <th rowspan="2" style="font-weight:bold">&nbsp;</th>
                      <th rowspan="2" style="font-weight:bold">1</th>
                      <th rowspan="2" style="font-weight:bold">2</th>
                      <th rowspan="2" style="font-weight:bold">3</th>
                      <th colspan="3" style="font-weight: normal">орлого</th>
                      <th colspan="3" style="font-weight: normal">зардал</th>                    
                      <th rowspan="2" style="font-weight:bold">4</th>
                    </tr>
                    <tr class="oddRow">                    
                      <th style="width: 80px; font-weight: normal">төлөвлөгөө</th>
                      <th style="width: 80px; font-weight: normal">гүйцэтгэл</th>
                      <th style="width: 80px; font-weight: normal">биелэлт</th>
                      <th style="width: 80px; font-weight: normal">төлөвлөгөө</th>
                      <th style="width: 80px; font-weight: normal">гүйцэтгэл</th>
                      <th style="width: 80px; font-weight: normal">биелэлт</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(t,i) in list">
                    <tr v-if="isDrawGroup(i) && t.mainType!=null">
                      <td style="font-weight:bold; background-color: #cae0ff" colspan="11">{{t.mainType}}</td>
                    </tr>
                    <tr>
                      <template v-if="isDrawGroup(i)">
                        <td :rowspan="prodRowCount(t.projectId)">{{(i+1)+'.1'}}</td>
                        <td style="text-align: left"
                          :rowspan="prodRowCount(t.projectId)"
                        >
                            <b>Бүтээгдэхүүн {{i+1}}</b>
                            <br />
                            {{t.projectName}}
                        </td>
                      </template>
                      <td style="text-align: left">
                          <a @click="showTask(t)">{{(i+1)+'. '+t.task}}</a>
                      </td>
                      <td>
                        <template v-if="t.calendar.length>0">
                          <div v-for="(tc,tci) in t.calendar">
                            {{printDuration(tc.start, tc.end)}}  
                          </div>
                        </template>
                        <template v-else>
                          {{printDuration(t.dueStartDate, t.dueDate)}}
                        </template>
                      </td>

                      <td>
                        <span style="color: green" v-if="t.incomePlan>0">{{t.incomePlan | formatMoney(',','.')}}</span>
                        <span v-else></span>
                      </td>
                      <td>
                        <span style="color: orangered" v-if="t.incomeExec>0">{{t.incomeExec | formatMoney(',','.')}}</span>
                        <span v-else></span>
                      </td>
                      <td>
                        <template v-if="t.incomePlan>0">
                          <span v-if="t.incomeExec==null || t.incomeExec==0" style="color: red">0%</span>
                          <div v-else>
                            {{((t.incomeExec*100)/t.incomePlan).toFixed(2)+'%'}}
                            <p class="m-t-xs text-muted">
                              {{(t.incomePlan-t.incomeExec) | formatMoney(',','.') }}
                              <span v-if="t.incomeExec>t.incomePlan" style="color: blue" class="p-t-xs">давуулан биелүүлсэн</span>
                            </p>
                          </div>
                        </template>
                        <div v-else-if="t.incomeExec>0">
                          {{t.incomeExec | formatMoney(',','.') }}
                          <p style="color: blue">төлөвлөөгүй орлого</p>
                        </div>
                      </td>
                      <td>
                        <span style="color: green" v-if="t.expensePlan>0">{{t.expensePlan | formatMoney(',','.')}}</span>
                        <span v-else></span>
                      </td>
                      <td>
                        <span style="color: orangered" v-if="t.expenseExec>0">{{t.expenseExec | formatMoney(',','.')}}</span>
                        <span v-else></span>
                      </td>
                      <td>
                        <template v-if="t.expensePlan>0">
                          <span v-if="t.expenseExec==null || t.expenseExec==0" style="color: red">0%</span>
                          <div v-else>
                            {{((t.expenseExec*100)/t.expensePlan).toFixed(2)+'%'}}
                            <p class="m-t-xs text-muted">
                              {{(t.expensePlan-t.expenseExec) | formatMoney(',','.') }}
                              <span v-if="t.expenseExec>t.expensePlan" style="color: purple" class="p-t-xs">зардал хэтэрсэн</span>
                            </p>
                          </div>
                        </template>
                        <div v-else-if="t.expenseExec>0">
                          {{(t.expenseExec*-1) | formatMoney(',','.') }}
                          <p style="color: purple">төлөвлөөгүй зардал</p>
                        </div>
                      </td>
                      
                      <td style="padding: 0">
                        <table v-if="!t.isTender" width="100%" class="tbl-user-execution">
                          <tr v-for="(u,ui) in t.sharedUsers">
                            <td style="width: 40%; text-align: right;"><a @click="handleUserInfoModal(u.id)">{{u.fullName}}</a>: <span v-if="u.perc>0" class="text-muted">{{u.perc}}%</span></td>
                            <td style="text-align: left; ">{{u.execution}}</td>
                          </tr>
                        </table>
                        <table v-else width="100%" class="tbl-user-execution">
                          <template v-for="(u,ui) in t.sharedUsers">
                            <tr>
                              <td style="width: 40%; text-align: right;"><a @click="handleUserInfoModal(u.id)">{{u.fullName}}</a>: </td>
                              <td v-if="ui==0" :rowspan="t.sharedUsers.length" style="text-align: left; border-bottom: none !important ">{{t.s1}}</td>
                            </tr>
                          </template>
                        </table>
                      </td>
                    </tr>
                  </template>
                  

                  <tr bgcolor="#e1e1e1">
                    <th colspan="4" class="p-xs">Нийт</th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      {{ (list.reduce((sum, l) => sum + l.incomePlan, 0)) | formatMoney(',','.') }}
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      {{ (list.reduce((sum, l) => sum + l.incomeExec, 0)) | formatMoney(',','.') }}
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      <p class="m-b-xs">{{ ((list.reduce((sum, l) => sum + l.incomeExec, 0))*100/(list.reduce((sum, l) => sum + l.incomePlan, 0))).toFixed(2)+'%' }}</p>
                      <template v-if="(list.reduce((sum, l) => sum + l.incomeExec, 0))>0">
                        {{ ((list.reduce((sum, l) => sum + l.incomePlan, 0))-(list.reduce((sum, l) => sum + l.incomeExec, 0))) | formatMoney(',','.') }}
                      </template>
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      {{ (list.reduce((sum, l) => sum + l.expensePlan, 0)) | formatMoney(',','.') }}
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      {{ (list.reduce((sum, l) => sum + l.expenseExec, 0)) | formatMoney(',','.') }}
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      <p class="m-b-xs">{{ ((list.reduce((sum, l) => sum + l.expenseExec, 0))*100/(list.reduce((sum, l) => sum + l.expensePlan, 0))).toFixed(2)+'%' }}</p>
                      <template v-if="(list.reduce((sum, l) => sum + l.expenseExec, 0))>0">
                        {{ ((list.reduce((sum, l) => sum + l.expensePlan, 0))-(list.reduce((sum, l) => sum + l.expenseExec, 0))) | formatMoney(',','.') }}
                      </template>
                    </th>
                    <th></th>
                  </tr>

                  </tbody>
                </table>
              </div> -->
            </div>
          </template>
          <template v-else-if="prms.mode == 6666">
            <!-- <div class="ivu-row m-b-sm">
              <div class="ivu-col ivu-col-span-4">
                <DatePicker v-model="dateStart"  @on-change="(value) => dateStart = value.toLocaleString()" format="yyyy/MM/dd" type="date" placeholder="Select date" style="width: 100%" transfer></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker v-model="dateEnd"  @on-change="(value) => dateEnd = value.toLocaleString()"  format="yyyy/MM/dd" type="date" placeholder="Select date" style="width: 100%" transfer></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-10"><depart-cascader :id="departId" :key="departComponentKey" v-model="departId"  @on-change="departChanged" /></div>
              <div class="ivu-col ivu-col-span-4 text-center">
              </div>
            </div> -->
            <div class="ivu-row m-b-sm">
              <div class="ivu-col ivu-col-span-4">
                <Select v-model="dateRangeMode">
                  <Option :value="-1" label="Өмнөх оны">Өмнөх оны</Option>
                  <Option :value="0" label="Бүтэн жилээр">Бүтэн жилээр</Option>
                  <Option :value="1" label="Энэ оны 1-р хагас">Энэ оны 1-р хагас</Option>
                  <Option :value="2" label="Энэ оны 2-р хагас">Энэ оны 2-р хагас</Option>
                  <Option :value="3" label="Энэ сараар">Энэ сараар</Option>
                  <Option :value="4" label="Дараа оны">Дараа оны</Option>
                </Select>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateStart"
                  @on-change="(value) => (dateStart = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-4">
                <DatePicker
                  v-model="dateEnd"
                  @on-change="(value) => (dateEnd = value.toLocaleString())"
                  format="yyyy/MM/dd"
                  type="date"
                  placeholder="Select date"
                  style="width: 100%"
                  transfer
                ></DatePicker>
              </div>
              <div class="ivu-col ivu-col-span-6">
                <depart-cascader
                  :id="departId"
                  :key="departComponentKey"
                  v-model="departId"
                  @on-change="departChanged"
                />
              </div>
              <div class="ivu-col ivu-col-span-4 text-center">
                <!-- <Button @click="init();" type="primary">Хайх</Button> -->
              </div>
            </div>

            <div id="printablePage">
              <table width="100%" align="center">
                <tbody>
                  <tr>
                    <td class style="text-align: left; font-size: 13px">
                      Хэвлэсэн: {{ formatAllDate(new Date()) }},
                      {{ $store.state.user.fullName }}
                    </td>
                    <td
                      style="text-align: right; font-size: 13px; width: 300px"
                    >
                      Хамрах хугацаа: {{ dateStart | formatDateYMD("/") }} -
                      {{ dateEnd | formatDateYMD("/") }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table width="100%" align="center">
                <tbody>
                  <tr>
                    <td
                      style="
                        padding-top: 20px;
                        font-size: 14px;
                        text-align: center;
                      "
                    >
                      <strong style="text-transform: uppercase"
                        >{{ getConfigValueByKey("companyName") }} - н
                        ТАЙЛАН</strong
                      >
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        padding-top: 20px;
                        font-size: 14px;
                        text-align: left;
                      "
                    ></td>
                  </tr>
                </tbody>
              </table>

              <table
                align="center"
                width="100%"
                border="1"
                bordercolor="#333"
                style="vertical-align: top"
                class="auto-style4"
              >
                <tbody>
                  <tr bgcolor="#e5f0ff">
                    <td>№&nbsp;</td>
                    <td width="10%">Үйл ажиллагааны чиглэл, бүтээгдэхүүн</td>
                    <td width="20%">
                      Зорилтыг хэрэгжүүлэх үйл ажиллагааны үе шатууд
                    </td>
                    <td width="120px">Хугацаа</td>
                    <th colspan="7">Төсөв</th>
                    <td>Хариуцан гүйцэтгэх ажилтан, Гүйцэтгэл</td>
                  </tr>

                  <tr class="oddRow">
                    <th rowspan="2" style="font-weight: bold">&nbsp;</th>
                    <th rowspan="2" style="font-weight: bold">1</th>
                    <th rowspan="2" style="font-weight: bold">2</th>
                    <th rowspan="2" style="font-weight: bold">3</th>
                    <th colspan="3" style="font-weight: normal">орлого</th>
                    <th colspan="3" style="font-weight: normal">зардал</th>
                    <th rowspan="2" style="font-weight: normal">үр дүн</th>
                    <th rowspan="2" style="font-weight: bold">4</th>
                  </tr>
                  <tr class="oddRow">
                    <th style="width: 80px; font-weight: normal">төлөвлөгөө</th>
                    <th style="width: 80px; font-weight: normal">гүйцэтгэл</th>
                    <th style="width: 80px; font-weight: normal">биелэлт</th>
                    <th style="width: 80px; font-weight: normal">төлөвлөгөө</th>
                    <th style="width: 80px; font-weight: normal">гүйцэтгэл</th>
                    <th style="width: 80px; font-weight: normal">биелэлт</th>
                  </tr>

                  <!-- <tr class="oddRow">
                      <td class="oddRow" style="font-weight:bold">&nbsp;</td>
                      <td width="15%" class="oddRow" style="font-weight:bold">1</td>
                      <td width="25%" style="font-weight:bold">2</td>
                      <td style="font-weight:bold">3</td>
                      <th colspan="6">Төсөв</th>
                      <td style="font-weight:bold">4</td>
                    </tr> -->

                  <template v-for="(t, i) in listDepart">
                    <tr v-if="isDrawGroupForDepart(i) && t.mainType != null">
                      <td
                        style="font-weight: bold; background-color: #cae0ff"
                        colspan="12"
                      >
                        {{ t.mainType }}
                      </td>
                    </tr>
                    <tr>
                      <template v-if="isDrawGroupForDepart(i)">
                        <td :rowspan="prodRowCountDepart(t.projectId)">
                          {{ i + 1 + ".1" }}
                        </td>
                        <td
                          style="text-align: left"
                          :rowspan="prodRowCountDepart(t.projectId)"
                        >
                          <b>Бүтээгдэхүүн {{ i + 1 }}</b>
                          <br />
                          {{ t.projectName }}
                        </td>
                      </template>
                      <td style="text-align: left">
                        <a @click="showTask(t)">{{ i + 1 + ". " + t.task }}</a>
                      </td>
                      <td>
                        <template v-if="t.calendar.length > 0">
                          <div v-for="(tc, tci) in t.calendar">
                            {{ printDuration(tc.start, tc.end) }}
                          </div>
                        </template>
                        <template v-else>
                          {{ printDuration(t.dueStartDate, t.dueDate) }}
                        </template>
                      </td>

                      <td>
                        <span style="color: green" v-if="t.incomePlan > 0">{{
                          t.incomePlan | formatMoney(",", ".")
                        }}</span>
                        <span v-else></span>
                      </td>
                      <td>
                        <span
                          style="color: orangered"
                          v-if="t.incomeExec > 0"
                          >{{ t.incomeExec | formatMoney(",", ".") }}</span
                        >
                        <span v-else></span>
                      </td>
                      <td>
                        <span v-if="t.incomePlan > 0">
                          <span
                            v-if="t.incomeExec == null || t.incomeExec == 0"
                            style="color: red"
                            >0%</span
                          >
                          <span v-else>{{
                            ((t.incomeExec * 100) / t.incomePlan).toFixed(2) +
                            "%"
                          }}</span>
                        </span>
                        <span v-else></span>
                      </td>
                      <td>
                        <span style="color: green" v-if="t.expensePlan > 0">{{
                          t.expensePlan | formatMoney(",", ".")
                        }}</span>
                        <span v-else></span>
                      </td>
                      <td>
                        <span
                          style="color: orangered"
                          v-if="t.expenseExec > 0"
                          >{{ t.expenseExec | formatMoney(",", ".") }}</span
                        >
                        <span v-else></span>
                      </td>
                      <td>
                        <span v-if="t.expensePlan > 0">
                          <span
                            v-if="t.expenseExec == null || t.expenseExec == 0"
                            style="color: red"
                            >0%</span
                          >
                          <span v-else>{{
                            ((t.expenseExec * 100) / t.expensePlan).toFixed(2) +
                            "%"
                          }}</span>
                        </span>
                        <span v-else></span>
                      </td>
                      <td></td>

                      <td style="padding: 0">
                        <table
                          v-if="!t.isTender"
                          width="100%"
                          class="tbl-user-execution"
                        >
                          <tr v-for="(u, ui) in t.sharedUsers">
                            <td style="width: 40%; text-align: right">
                              {{ u.fullName }}:
                              <span v-if="u.perc > 0" class="text-muted"
                                >{{ u.perc }}%</span
                              >
                            </td>
                            <td style="text-align: left">{{ u.execution }}</td>
                          </tr>
                        </table>
                        <table v-else width="100%" class="tbl-user-execution">
                          <template v-for="(u, ui) in t.sharedUsers">
                            <tr>
                              <td style="width: 40%; text-align: right">
                                {{ u.fullName }}:
                              </td>
                              <td
                                v-if="ui == 0"
                                :rowspan="t.sharedUsers.length"
                                style="
                                  text-align: left;
                                  border-bottom: none !important;
                                "
                              >
                                {{ t.s1 }}
                              </td>
                            </tr>
                          </template>
                        </table>
                      </td>
                    </tr>
                  </template>

                  <tr bgcolor="#e1e1e1">
                    <th colspan="4" class="p-xs">Нийт</th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      {{
                        list.reduce((sum, l) => sum + l.incomePlan, 0)
                          | formatMoney(",", ".")
                      }}
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      {{
                        list.reduce((sum, l) => sum + l.incomeExec, 0)
                          | formatMoney(",", ".")
                      }}
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      <p class="m-b-xs">
                        {{
                          (
                            (list.reduce((sum, l) => sum + l.incomeExec, 0) *
                              100) /
                            list.reduce((sum, l) => sum + l.incomePlan, 0)
                          ).toFixed(2) + "%"
                        }}
                      </p>
                      <template
                        v-if="
                          list.reduce((sum, l) => sum + l.incomeExec, 0) > 0
                        "
                      >
                        {{
                          (list.reduce((sum, l) => sum + l.incomePlan, 0) -
                            list.reduce((sum, l) => sum + l.incomeExec, 0))
                            | formatMoney(",", ".")
                        }}
                      </template>
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      {{
                        list.reduce((sum, l) => sum + l.expensePlan, 0)
                          | formatMoney(",", ".")
                      }}
                    </th>
                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      {{
                        list.reduce((sum, l) => sum + l.expenseExec, 0)
                          | formatMoney(",", ".")
                      }}
                    </th>

                    <th style="width: 80px; font-weight: normal" class="p-xs">
                      <p class="m-b-xs">
                        {{
                          (
                            (list.reduce((sum, l) => sum + l.expenseExec, 0) *
                              100) /
                            list.reduce((sum, l) => sum + l.expensePlan, 0)
                          ).toFixed(2) + "%"
                        }}
                      </p>
                      <template
                        v-if="
                          list.reduce((sum, l) => sum + l.expenseExec, 0) > 0
                        "
                      >
                        {{
                          (list.reduce((sum, l) => sum + l.expensePlan, 0) -
                            list.reduce((sum, l) => sum + l.expenseExec, 0))
                            | formatMoney(",", ".")
                        }}
                      </template>
                    </th>
                    <th></th>
                    <th></th>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-else-if="prms.mode == 7">
            <div id="printablePage">
              <table width="100%" align="center">
                <tbody>
                  <tr>
                    <td class style="text-align: left; font-size: 13px">
                      &nbsp;
                    </td>
                    <td
                      style="text-align: right; font-size: 13px; width: 300px"
                    >
                      <em style="text-align: right"
                        >“Төрийн жинхэнэ албан хаагчийн үйл ажиллагааны үр дүн,
                        мэргэшлийн түвшинг үнэлж дүгнэх журам”-ын хавсралт 2
                        (Төрийн жинхэнэ албан хаагчийн үйл ажиллагааны үр дүн,
                        мэргэшлийн түвшин /үр дүнгийн гэрээний биелэлт/-г үнэлэх
                        Үлгэрчилсэн загвар)</em
                      >
                    </td>
                  </tr>
                </tbody>
              </table>

              <table width="100%" align="center">
                <tbody>
                  <tr>
                    <td
                      style="
                        padding-top: 20px;
                        font-size: 14px;
                        text-align: center;
                      "
                    >
                      <strong contenteditable="true">
                        ҮР ДҮНГИЙН ГЭРЭЭНИЙ БИЕЛЭЛТИЙГ ДҮГНЭХ
                        <br />(ИЛТГЭХ ХУУДАС)
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div contenteditable="true">
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1.4.Тухайн төрийн жинхэнэ албан хаагчийн төрийн алба,
                    төрийн жинхэнэ албан хаагчтай холбоотой</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >хууль тогтоомж, төрийн албаны</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >болон</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >үйлчилгээний стандарт</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >ыг мөрдөх,</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >ёс зүй</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >н болон</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >ашиг сонирхлын зөрчлөөс сэргийлэх</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >тэй холбогдсон үүргийн биелэлтийн талаарх</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >дүгнэлт:</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >…………………………………………………………………………………………………………………………………………………………………………………………………….
                    ............................</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >2.Менежерийн үүргийн биелэлт
                  </span>
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >1.5.Менежерийн хүлээх үүргийн биелэлтийн талаарх төрийн
                    жинхэнэ албан хаагчийн сэтгэл ханамжийн түвшин
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1.5.1.Төрийн жинхэнэ албан хаагч гэрээний нөгөө тал болох
                    менежерийн хүлээсэн үүргийн биелэлтийг хэрхэн үнэлж
                    байгаагаа доорхи дөрвөлжний
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;аль тохироход
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;гэж
                    тэмдэглэнэ.</span
                  >
                  <img
                    height="25px;"
                    src="http://api.gosmart.mn/img/acpr/sw9It8xmWx6aWhZNWTxo7lQ.png?w=23&amp;h=25&amp;rev=1&amp;ac=1"
                    style="
                      border: none;
                      transform: rotate(0rad);
                      -webkit-transform: rotate(0rad);
                    "
                    width="23px;"
                  />
                </p>
                <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  height="41px;"
                  src="http://api.gosmart.mn/img/acpr/swyoLNIMjjujQqEqp7TXGYA.png?w=51&amp;h=41&amp;rev=1&amp;ac=1"
                  style="
                    border: none;
                    transform: rotate(0rad);
                    -webkit-transform: rotate(0rad);
                  "
                  width="51px;"
                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  height="35px;"
                  src="http://api.gosmart.mn/img/acpr/sXq3ACSj--7GGqFdSpWEFjg.png?w=44&amp;h=35&amp;rev=1&amp;ac=1"
                  style="
                    border: none;
                    transform: rotate(0rad);
                    -webkit-transform: rotate(0rad);
                  "
                  width="44px;"
                />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  height="35px;"
                  src="http://api.gosmart.mn/img/acpr/sMQuFA_WLCGDpKjfPrgSbCA.png?w=44&amp;h=35&amp;rev=1&amp;ac=1"
                  style="
                    border: none;
                    transform: rotate(0rad);
                    -webkit-transform: rotate(0rad);
                  "
                  width="44px;"
                />
                <br />
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Бага
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Дунд
                    &nbsp;зэрэг
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Их</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1.6. Эрхэлж байгаа ажлынхаа талаарх төрийн жинхэнэ албан
                    хаагчийн сэтгэл ханамжийн түвшин</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1.6.1.Одоогийн эрхэлж байгаа ажилдаа хэр зэрэг сэтгэл
                    ханамжтай байгаагаа үнэлж, доорхи дөрвөлжний аль тохироход
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;гэж
                    тэмдэглэнэ.</span
                  >
                  <img
                    height="33px;"
                    src="http://api.gosmart.mn/img/acpr/skJM5fMZwAn7wHQuZ31qzAg.png?w=40&amp;h=33&amp;rev=1&amp;ac=1"
                    style="
                      border: none;
                      transform: rotate(0rad);
                      -webkit-transform: rotate(0rad);
                    "
                    width="40px;"
                  />
                </p>
                <br />
                <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  height="33px;"
                  src="http://api.gosmart.mn/img/acpr/sq-rAiYoaqv9zgefmKpNpVA.png?w=47&amp;h=33&amp;rev=1&amp;ac=1"
                  style="
                    border: none;
                    transform: rotate(0rad);
                    -webkit-transform: rotate(0rad);
                  "
                  width="47px;"
                />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  height="33px;"
                  src="http://api.gosmart.mn/img/acpr/sqffMrD5zF23itO1JuCp-gA.png?w=43&amp;h=33&amp;rev=1&amp;ac=1"
                  style="
                    border: none;
                    transform: rotate(0rad);
                    -webkit-transform: rotate(0rad);
                  "
                  width="43px;"
                />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  height="33px;"
                  src="http://api.gosmart.mn/img/acpr/sd8dFsXFLkp1gyV93m9QZ8Q.png?w=45&amp;h=33&amp;rev=1&amp;ac=1"
                  style="
                    border: none;
                    transform: rotate(0rad);
                    -webkit-transform: rotate(0rad);
                  "
                  width="45px;"
                />
                <br />
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      style="
                        color: rgb(0, 0, 0);
                        font-family: 'Times New Roman';
                        font-size: medium;
                        font-style: normal;
                        font-variant: normal;
                        font-weight: normal;
                        letter-spacing: normal;
                        line-height: normal;
                        orphans: auto;
                        text-align: start;
                        text-indent: 0px;
                        text-transform: none;
                        white-space: normal;
                        widows: 1;
                        word-spacing: 0px;
                        -webkit-text-stroke-width: 0px;
                        display: inline !important;
                        float: none;
                      "
                    >
                      <span class="Apple-converted-space">&nbsp;</span
                      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                    >Бага
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Дунд
                    зэрэг
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Их
                    &nbsp;&nbsp;&nbsp;
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    3. Тайлангийн баталгаажуулалт
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Ажлын гүйцэтгэлээ тайлагнасан төрийн жинхэнэ албан
                    хаагч:</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >…………………………………… &nbsp;&nbsp;&nbsp;/ ……………………………………. /
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >(гарын үсэг)</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >………………………
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(огноо)</span
                  >
                </p>
                <br />
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >ХОЁР. ГЭРЭЭНИЙ БИЕЛЭЛТИЙН ҮНЭЛГЭЭ, ХЭРЭГЖҮҮЛЭХ АРГА
                    ХЭМЖЭЭ</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    4. Гэрээний биелэлтийн үнэлгээ
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    margin-left: 17.85pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >4.1.Менежер төрийн жинхэнэ албан хаагчийн гэрээгээр
                    хүлээсэн үүргийн биелэлтийг дүгнэж, &nbsp;дор дурдсан дундаж
                    оноогоор үнэлэв:</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    margin-left: 17.85pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Хүснэгт
                    4
                  </span>
                </p>
                <div dir="ltr" style="margin-left: -5.75pt">
                  <table style="border: none; border-collapse: collapse">
                    <colgroup>
                      <col width="310" />
                      <col width="113" />
                      <col width="146" />
                    </colgroup>
                    <tbody>
                      <tr style="height: 0px">
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: italic;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >Гэрээний үзүүлэлт</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: italic;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >Өгвөл зохих дундаж оноо</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: italic;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >Өгсөн дундаж оноо</span
                            >
                          </p>
                        </td>
                      </tr>
                      <tr style="height: 0px">
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >1</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >2</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >3</span
                            >
                          </p>
                        </td>
                      </tr>
                      <tr style="height: 0px">
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >1.Нийт ажил, үйлчилгээ (гарц)-ний биелэлт</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >0-30</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                        </td>
                      </tr>
                      <tr style="height: 0px">
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >2.Тусгай ажил, үйлчилгээ (гарц)-ний биелэлт</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >0-40</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                        </td>
                      </tr>
                      <tr style="height: 0px">
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >3.Мэдлэг чадвараа дээшлүүлэх зорилтын
                              биелэлт</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >0-30</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                        </td>
                      </tr>
                      <tr style="height: 0px">
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: italic;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >Н и й т &nbsp;&nbsp;о н о о</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >0-100</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    margin-left: 17.85pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    margin-left: 17.85pt;
                    text-indent: 18.15pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    4.2.Менежер &nbsp;гэрээг дүгнэж өгсөн үнэлгээгээ
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <img
                      height="24px;"
                      src="http://api.gosmart.mn/img/acpr/sDKCcbRIyJEHiCa0Zr4-uZA.png?w=36&amp;h=24&amp;rev=1&amp;ac=1"
                      style="
                        border: none;
                        transform: rotate(0rad);
                        -webkit-transform: rotate(0rad);
                      "
                      width="36px;"
                    />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;гэж
                    тэмдэглэнэ:
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;Хүснэгт 5
                  </span>
                </p>
                <div dir="ltr" style="margin-left: -5.75pt">
                  <table style="border: none; border-collapse: collapse">
                    <colgroup>
                      <col width="114" />
                      <col width="114" />
                      <col width="114" />
                      <col width="120" />
                      <col width="114" />
                    </colgroup>
                    <tbody>
                      <tr style="height: 36px">
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.2;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“А”</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >буюу</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“Маш сайн”</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“В”</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >буюу</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“Сайн”</span
                            >
                          </p>
                          <br />
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.3800000000000001;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“С”</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >буюу</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“Хангалттай</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >”</span
                            >
                          </p>
                          <br />
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.2;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“D”</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >буюу</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“Дутагдалтай”</span
                            >
                          </p>
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <p
                            dir="ltr"
                            style="
                              line-height: 1.2;
                              margin-top: 0pt;
                              margin-bottom: 0pt;
                              text-align: justify;
                            "
                          >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“F”</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 400;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >буюу</span
                            >
                            <span
                              style="
                                font-size: 14.666666666666666px;
                                font-family: Arial;
                                color: #000000;
                                background-color: transparent;
                                font-weight: 700;
                                font-style: normal;
                                font-variant: normal;
                                text-decoration: none;
                                vertical-align: baseline;
                                white-space: pre-wrap;
                              "
                              >“Хангалтгүй”</span
                            >
                          </p>
                        </td>
                      </tr>
                      <tr style="height: 52px">
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                          <img
                            height="33px;"
                            src="http://api.gosmart.mn/img/acpr/sbv_aDjrS7H-UtsTHWUuvdg.png"
                            style="
                              border: none;
                              transform: rotate(0rad);
                              -webkit-transform: rotate(0rad);
                            "
                            width="37px;"
                          />
                          <br />
                          <br />
                          <br />
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                          <img
                            height="33px;"
                            src="http://api.gosmart.mn/img/acpr/slxO0gZzjY58WwbhYEHtvJg.png"
                            style="
                              border: none;
                              transform: rotate(0rad);
                              -webkit-transform: rotate(0rad);
                            "
                            width="37px;"
                          />
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                          <img
                            height="33px;"
                            src="http://api.gosmart.mn/img/acpr/s8EvbE78Kjj5ce0BS_lOGsg.png"
                            style="
                              border: none;
                              transform: rotate(0rad);
                              -webkit-transform: rotate(0rad);
                            "
                            width="37px;"
                          />
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                          <img
                            height="33px;"
                            src="http://api.gosmart.mn/img/acpr/s9cri3iYfyocOjLjdmg7Btw.png"
                            style="
                              border: none;
                              transform: rotate(0rad);
                              -webkit-transform: rotate(0rad);
                            "
                            width="37px;"
                          />
                        </td>
                        <td
                          style="
                            border-left: solid #000000 1px;
                            border-right: solid #000000 1px;
                            border-bottom: solid #000000 1px;
                            border-top: solid #000000 1px;
                            vertical-align: top;
                            padding: 0px 8px 0px 8px;
                          "
                        >
                          <br />
                          <img
                            height="33px;"
                            src="http://api.gosmart.mn/img/acpr/slvXz1VJaRRFZuWHZL_QxtA.png"
                            style="
                              border: none;
                              transform: rotate(0rad);
                              -webkit-transform: rotate(0rad);
                            "
                            width="37px;"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    margin-left: 17.85pt;
                    text-indent: 18.15pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >5.Менежерийн тэмдэглэл:</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >5.1.Хэрэв төрийн жинхэнэ албан хаагчид</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >“А”</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >буюу</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >“Маш сайн</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    ”, эсхүл
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >“D”</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >буюу</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >“Дутагдалтай”</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >,</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >“F”</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >буюу</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >“Хангалтгүй”</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    үнэлгээ өгсөн бол үндэслэл:
                    ……………………………………………………………………….............................................................................................................................................................................
                  </span>
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >...........................</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >5.2.Гэрээний биелэлтийн үнэлгээг үндэслэн &nbsp;хэрэгжүүлэх
                    арга хэмжээний санал:</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1) ……………………………………………………………………………………..</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >2)……………………………………………………………………………… г.м.</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >6. Дараагийн &nbsp;шатны даргын тэмдэглэл</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >6.1.Менежерийн &nbsp;үнэлгээг:
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Зөвшөөрсөн
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                  <img
                    height="13px;"
                    src="http://api.gosmart.mn/img/acpr/sVh6WlpMyVq_82rVy4tuziQ.png?w=17&amp;h=13&amp;rev=1&amp;ac=1"
                    style="
                      border: none;
                      transform: rotate(0rad);
                      -webkit-transform: rotate(0rad);
                    "
                    width="17px;"
                  />
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span
                      class="Apple-tab-span"
                      style="white-space: pre"
                    ></span>
                  </span>
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                  >
                    <span class="Apple-tab-span" style="white-space: pre"></span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Зөвшөөрөхгүй
                  </span>
                  <img
                    height="13px;"
                    src="http://api.gosmart.mn/img/acpr/sUwfXUE1Zub_HehtfaqMWpA.png?w=17&amp;h=13&amp;rev=1&amp;ac=1"
                    style="
                      border: none;
                      transform: rotate(0rad);
                      -webkit-transform: rotate(0rad);
                    "
                    width="17px;"
                  />
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >6.2.Зөвшөөрөхгүй тохиолдолд:</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >1)Үндэслэл: ……………………………………………………………………………………...</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >……………………………………………………………………………………………………………............................................................................................................................................................</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >2)Дараагийн шатны даргын үнэлгээ:</span
                  >
                  <img
                    height="25px;"
                    src="http://api.gosmart.mn/img/acpr/sBaI5-RI5-eLNkKnIaCfBfQ.png?w=225&amp;h=25&amp;rev=1&amp;ac=1"
                    style="
                      border: none;
                      transform: rotate(0rad);
                      -webkit-transform: rotate(0rad);
                    "
                    width="225px;"
                  />
                </p>
                <br />
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >7. Гэрээний биелэлтийн үнэлгээний баталгаажуулалт</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-indent: 36pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >7.1.Үнэлгээ өгсөн:</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Менежер</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Хэлтэсийн дарга нэр &nbsp;&nbsp;/ ……………………………………../</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >&nbsp;&nbsp;&nbsp;(</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >албан тушаал)
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(гарын
                    үсэг)</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Тэмдэг</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >………………………….
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;............................................
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(огноо)</span
                  >
                </p>
                <br />
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Дараагийн шатны дарга</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Байгууллагын орлогч нэр &nbsp;&nbsp;/
                    ……………………....………………../</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >албан тушаал)
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(гарын
                    үсэг)
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >…………………………. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(огноо)</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Дараагийн шатны дарга</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Байгууллагын дарга нэр &nbsp;&nbsp;/
                    ……………………....………………../</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >албан тушаал)
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(гарын
                    үсэг)
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >…………………………. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(огноо)</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >7.2.Үнэлгээтэй танилцсан:</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 700;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Төрийн жинхэнэ албан хаагч</span
                  >
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  &nbsp;
                </p>
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >Хэлтэс мэргэжилтэн нэр &nbsp;&nbsp;/…………………………………../
                    &nbsp;</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >(гарын үсэг)</span
                  >
                </p>
                <br />
                <p
                  dir="ltr"
                  style="
                    line-height: 1.2;
                    margin-top: 0pt;
                    margin-bottom: 0pt;
                    text-align: justify;
                  "
                >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: normal;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >……………………….
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                  <span
                    style="
                      font-size: 14.666666666666666px;
                      font-family: Arial;
                      color: #000000;
                      background-color: transparent;
                      font-weight: 400;
                      font-style: italic;
                      font-variant: normal;
                      text-decoration: none;
                      vertical-align: baseline;
                      white-space: pre-wrap;
                    "
                    >(огноо)</span
                  >
                </p>
              </div>
            </div>
          </template>
        </div>
      </Col>
    </Row>

    <template v-if="detailingDrawerTaskModel.render">
      <!-- <detail-drawer
        :prms="detailingDrawerTaskModel"
        @on-detail-closed="detailingDrawerTaskModel.id = 0"
      ></detail-drawer> -->
    </template>
  </b-sidebar>
</template>
<script>
import "./planReport.less";

import { getConfigValueByKey } from "@/libs/util";
import { request } from "@/api/all";
// import { mainReportData } from "@/api/project";
// import { getInheritedDepart } from "@/api/hr";

import {
  hasOneOf,
  formatMoney,
  formatAllDate,
  formatDateMD,
} from "@/libs/tools";

//import { formatAllDate } from "@/libs/tools";

//import departCascader from "@/view/task/component/cascader/depart.vue";

import { mapActions } from "vuex";

//import { MenuIcon } from "vue-feather-icons";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import "element-ui/lib/theme-chalk/index.css";
import { Row, Col, DatePicker, Select, Option } from "element-ui";

const moment = require("moment");

var counter = 1;
export default {
  name: "planRptDrawer",
  components: {
    Row,
    Col,
    DatePicker,
    Select,
    Option,
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    //MenuIcon,
    //departCascader,
    // detailDrawer: () => ({
    //   component: import("@/view/task/detail/ondrawer.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 300,
    //   timeout: 5000,
    // }),
  },
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    prmsMode: {
      type: Number,
      default: () => 0,
    },
    prms: {
      type: Object,
      default: () => {},
    },
    drwrW: {
      type: String,
      default: () => "100vw",
    },
    projectTag: {
      type: Number,
      default: () => -1,
    },
  },
  data() {
    return {
      profileShow: false,

      list: [],
      departCurName: "",
      listDepartFlat: [],
      listDepart: [],
      listUser: [],
      coreSearchModel: {},
      departId: 0,
      departComponentKey: 0,

      dateRangeMode: 0,
      dateStart: "",
      dateEnd: "",

      detailingDrawerTaskModel: {
        render: false,
        id: 0,
      },

      chiefData: {
        loaded: false,
        depart: "",
        chief: "",
      },

      list2022: {
        listRaw: [],
        list: [],
        typesRaw: [],
        types: [],
        zoriltsRaw: [],
        zorilts: [],
        mainList: [],
      },
      zoriltIndex: 0,
      temp: 0,
    };
  },
  computed: {
    isShow: {
      get: function () {
        this.profileShow = this.show;
        return this.profileShow;
      },
      set: function () {},
    },
  },
  watch: {
    prmsMode: function (newv, oldv) {
      if (newv > 0) {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["getGroupDefaultProjects", "handleUserInfoModal"]),
    sp_no: function* () {
      let id = 1;
      while (true) {
        yield id;
        id++;
      }
    },
    showTask(e) {
      this.detailingDrawerTaskModel.render = true;
      this.$nextTick(function () {
        this.detailingDrawerTaskModel.id = e.id;
      });
    },
    downloadRep() {
      window.open(
        "data:application/vnd.ms-excel," +
          encodeURIComponent($("#printablePage").html())
      );
    },
    departChanged(e) {
      this.listDepart = this.list.filter(
        (l) => l.sharedUsers.filter((u) => u.departId == e).length > 0
      );
    },
    onDepFlat(val) {
      this.listDepartFlat = val;
    },
    departChanged2(e) {
      if (this.listDepartFlat.filter((x) => x.id == e).length) {
        this.departCurName = this.listDepartFlat.filter((x) => x.id == e)[0][
          "label"
        ];
      }
      this.departf;
      this.list2022.mainList = [];
      this.list2022.types.forEach((tc) => {
        var temp = { tc: tc, pt: [] };
        this.list2022.zorilts
          .filter((pt) => pt.code != "yr_2022")
          .forEach((pt) => {
            var temppt = { pt: pt, tasks: [] };
            this.list2022.list
              .filter(
                (x) =>
                  x.sharedUsers.filter((u) => u.departId == e).length > 0 &&
                  x.projectType != null &&
                  x.projectType.id == pt.id &&
                  x.locTypeId == tc.id
              )
              .forEach((task) => {
                temppt.tasks.push(task);
              });
            if (temppt.tasks.length > 0) temp.pt.push(temppt);
          });

        if (temp.pt.length > 0) {
          this.list2022.mainList.push(temp);
        }
      });
    },
    formatMoney(n, c, d, t) {
      return formatMoney(n, c, d, t);
    },
    formatAllDate(v) {
      return formatAllDate(v);
    },
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      if (this.dateRangeMode == -1) {
        this.dateStart = moment()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY/MM/DD");
        this.dateEnd = moment(this.dateStart)
          .endOf("year")
          .format("YYYY/MM/DD");
      } else if (this.dateRangeMode == 0) {
        this.dateStart = moment().startOf("year").format("YYYY/MM/DD");
        this.dateEnd = moment().endOf("year").format("YYYY/MM/DD");
      } else if (this.dateRangeMode == 1) {
        this.dateStart = moment().startOf("year").format("YYYY/MM/DD");
        this.dateEnd = moment(this.dateStart)
          .add(5, "M")
          .endOf("month")
          .format("YYYY/MM/DD");
      } else if (this.dateRangeMode == 2) {
        this.dateStart = moment()
          .startOf("year")
          .add(6, "M")
          .format("YYYY/MM/DD");
        this.dateEnd = moment().endOf("year").format("YYYY/MM/DD");
      } else if (this.dateRangeMode == 3) {
        this.dateStart = moment().startOf("month").format("YYYY/MM/DD");
        this.dateEnd = moment().endOf("month").format("YYYY/MM/DD");
      } else if (this.dateRangeMode == 4) {
        this.dateStart = moment()
          .add(1, "years")
          .startOf("year")
          .format("YYYY/MM/DD");
        this.dateEnd = moment(this.dateStart)
          .endOf("year")
          .format("YYYY/MM/DD");
      }

      this.list = [];
      this.listUser = [];

      this.list2022.listRaw = [];
      this.list2022.list = [];

      this.list2022.types = [];
      this.list2022.typesRaw = [];

      this.list2022.zorilts = [];
      this.list2022.zoriltsRaw = [];

      this.list2022.mainList = [];

      //   mainReportData({
      //     tag: this.projectTag,
      //     start: this.dateStart,
      //     end: this.dateEnd,
      //     fullData: this.prms.mode == 5 || this.prms.mode == 6 ? true : false,
      //   })

      request({
        api: { method: "GET", url: "Project/MainReportData" },
        params: {
          tag: this.projectTag,
          start: this.dateStart,
          end: this.dateEnd,
          fullData: this.prms.mode == 5 || this.prms.mode == 6 ? true : false,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.departId = this.$store.state.user.userInfo.departId;
          this.departComponentKey++;

          if (
            this.prms.mode == 5 ||
            this.prms.mode == 6 ||
            this.prms.mode == 66
          ) {
            this.list2022.list = res.data.tasks;
            this.list2022.types = res.data.types;
            this.list2022.zorilts = res.data.zorilts;

            this.list2022.types.forEach((tc) => {
              var temp = { tc: tc, pt: [] };
              this.list2022.zorilts
                .filter((pt) => pt.code != "yr_2022")
                .forEach((pt) => {
                  var temppt = { pt: pt, tasks: [] };
                  this.list2022.list
                    .filter(
                      (x) =>
                        x.projectType != null &&
                        x.projectType.id == pt.id &&
                        x.locTypeId == tc.id
                    )
                    .forEach((task) => {
                      temppt.tasks.push(task);
                    });
                  if (temppt.tasks.length > 0) temp.pt.push(temppt);
                });

              if (temp.pt.length > 0) {
                this.list2022.mainList.push(temp);
              }
            });

            if (this.prms.mode == 6) {
              this.listDepartFlat = this.$refs.dprtCsdr2.departsFlat;
              this.departChanged2(this.departId);
            }
          }

          this.list = res.data.tasks;
          this.listUser = this.list.filter(
            (t) =>
              t.sharedUsers.filter(
                (u) => u.userId == this.$store.state.user.userId
              ).length > 0
          );

          this.chiefData.loaded = false;
          if (this.prms.mode == 3) {
            //getInheritedDepart({  })

            request({
              api: { method: "GET", url: "Hr/GetInheritedDepart" },
              params: {
                id: this.departId,
              },
              store: this.$store,
            }).then((resd) => {
              this.chiefData.loaded = true;
              this.chiefData.depart = resd.data.depart.depart + "-н дарга";
              this.chiefData.chief = resd.data.depart.chiefUser.fullName;
            });
          }

          this.departChanged(this.departId);
        }
      });
    },
    isDrawGroup(i) {
      if (i == 0) {
        return true;
      } else if (this.list[i].projectName != this.list[i - 1].projectName) {
        return true;
      } else {
        return false;
      }
    },
    isDrawGroupForDepart(i) {
      if (i == 0) {
        return true;
      } else if (
        this.listDepart[i].projectId != this.listDepart[i - 1].projectId
      ) {
        return true;
      } else {
        return false;
      }
    },
    isDrawGroupForUser(i) {
      if (i == 0) {
        return true;
      } else if (this.listUser[i].projectId != this.listUser[i - 1].projectId) {
        return true;
      } else {
        return false;
      }
    },
    isDrawDepart(i, di) {
      if (di == 0) {
        return true;
      } else if (
        this.list[i].sharedUsers[di].departName !=
        this.list[i].sharedUsers[di - 1].departName
      ) {
        return true;
      } else {
        return false;
      }
    },
    prodRowCount(id) {
      return this.list.filter((t) => t.projectId == id).length;
    },
    prodRowCountDepart(id) {
      let self = this;
      if (self.departId > 0)
        return this.listDepart.filter((t) => t.projectId == id).length;
      else return this.list.filter((t) => t.projectId == id).length;
    },
    prodRowCountUser(id, uid) {
      return this.listUser.filter((t) => t.projectId == id).length;
    },
    isInMonth(mi, start, end, taskObj) {
      let s = new Date(start);
      let e = new Date(end);
      let rv = false;

      if (taskObj.calendar.length > 0) {
        for (var ci = 0; ci < taskObj.calendar.length; ci++) {
          if (
            mi >= new Date(taskObj.calendar[ci].start).getMonth() + 1 &&
            mi <= new Date(taskObj.calendar[ci].end).getMonth() + 1
          ) {
            rv = true;
          }
        }
        //rv= true;
      } else {
        if (mi >= s.getMonth() + 1 && mi <= e.getMonth() + 1) {
          rv = true;
        }
      }

      return rv;
    },
    isInDate(mi, wi, start, end, taskObj) {
      if (counter == NaN || counter == 49) {
        counter = 1;
      }

      let rv = false;
      for (var ci = 0; ci < taskObj.calendar.length; ci++) {
        let s = new Date(taskObj.calendar[ci].start);
        let e = new Date(taskObj.calendar[ci].end);

        let startNew = s.getMonth() * 4;
        let startNewX = parseInt(s.getDate() / 7, 10);

        if (s.getDate() % 7 != 0) {
          if (s.getDate() < 29) {
            startNewX = startNewX + 1;
          }
        }
        startNew = startNewX + startNew;

        let endNew = e.getMonth() * 4;
        let endNewX = parseInt(e.getDate() / 7, 10);

        if (e.getDate() % 7 != 0) {
          if (e.getDate() < 29) {
            endNewX = endNewX + 1;
          }
        }
        endNew = endNewX + endNew;
        if (startNew <= counter && counter <= endNew) {
          rv = true;
        }
      }

      counter++;
      return rv;
    },
    wname(i) {
      let rv = "";
      switch (i) {
        case 1:
          rv = "I";
          break;
        case 2:
          rv = "II";
          break;
        case 3:
          rv = "III";
          break;
        case 4:
          rv = "IV";
          break;
        default:
          break;
      }
      return rv;
    },
    filterByDepart(users) {
      let _td = [];
      _td.push(this.departId);
      if (this.departId > 0) {
        if (
          hasOneOf(
            users.map(function (e) {
              return e.departId;
            }),
            _td
          )
        )
          return true;
        else return false;
      } else return true;
    },
    filterByUser(users, uid) {
      if (
        hasOneOf(
          users.map(function (e) {
            return e.userId;
          }),
          uid
        )
      )
        return true;
      else return false;
    },
    getTitle() {
      let rv = "";
      switch (this.prms.mode) {
        case 1:
          rv = "Байгууллагын төлөвлөгөө";
          break;
        case 2:
          rv = "Хэлтсийн төлөвлөгөө";
          break;
        case 3:
          rv = "Үр дүнгийн төлөвлөгөө";
          break;
        case 4:
          rv = "Үр дүнгийн гэрээ";
          break;
        case 5:
          rv = "Байгууллагын тайлан";
          break;
        case 6:
          rv = "Хэлтсийн тайлан";
          break;
        case 7:
          rv = "Үр дүнгийн тайлан";
          break;
        case 66:
          rv = "Үр дүнгийн тайлан";
          break;
        default:
          break;
      }

      return rv;
    },
    visibleChanged(e) {
      if (!e) {
        this.$emit("on-drawer-close");
      }
    },
    printDuration(s, e) {
      return formatDateMD(s, ".") + " - " + formatDateMD(e, ".");
    },

    printDurationForPlan(s, e) {
      return formatDateMD(s, ".") + "<br />-<br/>" + formatDateMD(e, ".");
    },
    getNum(v) {
      let rv = "";
      switch (v) {
        case 1:
          rv = "Нэг";
          break;
        case 2:
          rv = "Хоёр";
          break;
        case 3:
          rv = "Гурав";
          break;
        case 4:
          rv = "Дөрөв";
          break;
        case 5:
          rv = "Тав";
          break;
        case 6:
          rv = "Зургаа";
          break;
        case 7:
          rv = "Долоо";
          break;
        case 8:
          rv = "Найм";
          break;
        case 9:
          rv = "Ес";
          break;
        case 10:
          rv = "Арав";
          break;
        default:
          break;
      }

      return rv;
    },
    gormatDec(dec) {
      let rv = "";
      if (dec >= 1000000000) {
        rv = Math.floor(dec / 1000000000) + " тэрбум";
      } else if (dec >= 1000000 && dec < 1000000000) {
        rv = Math.floor(dec / 1000000) + " сая";
      } else if (dec >= 1000 && dec < 1000000) {
        rv = Math.floor(dec / 1000) + " мянга";
      }

      return rv;
    },
    isInDate2(wi, beginDate, endDate) {
      let rv = "inherit";
      if (
        wi >= moment(beginDate).quarters() &&
        wi <= moment(endDate).quarters()
      ) {
        rv = "#4791b5";
      }
      return rv;
    },
  },
};
</script>